import {useEffect, useState} from 'react';
import {Trans} from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { useAuth } from '@common/auth/use-auth';
import { useSheetNameAction } from '@app_modules/requests/use-sheet-name-action';

type ExecuteSheetNameActionProps = {
  id: number,
  pindex: number;
  market_rate_date: string;
  investor_code: string
  fileItems: any,
};
export function SheetNameAction( {id, pindex, market_rate_date, investor_code, fileItems}: ExecuteSheetNameActionProps) {
  
  const files = fileItems.length > 0 ? fileItems[0]['files'] : [];
  const {user} = useAuth();

  const [fileLength, setFileLength] = useState(0);
  useEffect(() => {
    
    setFileLength(fileItems.length);
  }, [fileItems]);

  const executeSheetNameAction = useSheetNameAction(market_rate_date, investor_code, files);

  return (
    <>
      <Button
        size={'xs'} variant="flat" color="orange"
        type="submit"
        onClick={() => {
          executeSheetNameAction.mutate(
            {market_rate_date: market_rate_date, investor_code: investor_code, files: files},
            {
              onSuccess: (response) => {
                //onProcess(response.status, response.total_files, response.uploaded_date, response.file_name);
              },

            },
          );
        }}
        disabled={!fileLength || executeSheetNameAction.isPending || !investor_code}
        >
        <Trans message={`Detect Program`} />
      </Button>
    </>

  );
}
